import React, { useContext, useEffect, useRef, useState } from "react";
import { Modal } from "bootstrap";
import { NoteMessageContainer } from "../../../Layout/Common/alert/noteMessageContainer";
import { NOTEMESSAGE } from "../../../constants";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import { GlobalContext } from "../../../Context/GlobalContext";
import { isAlphaNumericAndSpace_, showWishListCreateToaster } from "../../../Layout/Common/common";
import { ValidationErrorMessage } from "../../../Layout/Common/alert/validationErrorMessage";
import { useNavigate } from "react-router-dom";
import { PAGES } from "../../../routeConfig";
import { useModalPopupManager } from "../../../Context/modelPopupContext";

export const CreateNewListPopup = () => {
  const { SHIPPINGNOTAVAILABLE } = NOTEMESSAGE;
  const { wishListAll, setWishListAll } = useContext(GlobalContext);
  const modalRef = useRef(null);
  const modalInstance = useRef(null);
  const { createNewList } = useGlobalFunction();
  const [newListName, SetNewListName] = useState("");
  const [errorMessage, SetErrorMessage] = useState("");
  const [showValidationMessage, SetShowValidationMessage] = useState(false);
  const navigate = useNavigate();
  const { registerModal } = useModalPopupManager();
  useEffect(() => {
    if (modalRef.current) {
      modalInstance.current = new Modal(modalRef.current, {
        backdrop: "static",
        keyboard: false,
      });
    }
  }, []);

  const handleShow = () => {
    registerModal(modalInstance.current);
    modalInstance.current?.show();
  };

  const handleHide = () => {
    modalInstance.current?.hide();
  };
  const handleOnType = (e) => {
    SetNewListName(isAlphaNumericAndSpace_(e.target.value));
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Optional, prevents form submission

      const value = isAlphaNumericAndSpace_(e.target.value);
      SetNewListName(value);

      handleCreateNewList(); // Call your function
    }
  };
  const handleCreateNewList = async () => {
    if (newListName) {
      let response = await createNewList(newListName);
      if (response) {
        if (response.data) {
          const whishList = JSON.parse(response.data);
          const newId = whishList.find((i) => i.listName == newListName);
          setWishListAll(whishList);
          showWishListCreateToaster();
          SetNewListName("");
          SetErrorMessage("");
          SetShowValidationMessage(false);
          handleHide();
          if (newId && newId.listId) navigate(PAGES.FAVORITEPRODUCT_LIST + "/" + newId.listId);
        } else if (response.message) {
          SetShowValidationMessage(true);
          SetErrorMessage(response.message);
        }
      }
    }
  };

  return (
    <>
      <div className="col-md-6 col-xxl-3 col-lg-4 mt-3 mt-lg-4">
        <div className="create-favList">
          <a onClick={handleShow}>
            <span className="wes-add" />
            <p>Create New List</p>
          </a>
        </div>
      </div>
      <div
        className="modal fade"
        id="addFavModal"
        tabIndex={-1}
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
        ref={modalRef}
      >
        <div className="modal-dialog modal-dialog-centered modal-animate-center product-notfound-dialog">
          <div className="modal-content">
            <p className="order-status-close" data-bs-dismiss="modal" onClick={handleHide}>
              <i className="fa-regular fa-circle-xmark" />
            </p>
            <div className="modal-body p-0">
              <div className="product-found">
                <div className="product-found-title">
                  <span className="wes-fav-lists" />
                  <h4>Create New Favorite List</h4>
                </div>
                <div className="product-found-body">
                  <form>
                    <div className="mb-3">
                      <label className="fs-15 mb-2">
                        List Name<span className="gl-form-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter List Name"
                        value={newListName}
                        onChange={handleOnType}
                        onKeyDown={handleKeyDown}
                        maxLength={20}
                      />
                      <p className="form-info fs-14 bg-darkGrey fw-normal mx-0 py-2">* Maximum 20 Characters</p>
                    </div>
                    <ValidationErrorMessage
                      show={showValidationMessage}
                      handleHidden={() => {
                        SetShowValidationMessage(false);
                      }}
                      message={errorMessage}
                    />
                    <div className="product-foundButton">
                      <div className="button-effect">
                        <button
                          type="button"
                          className="btn btn-products theme-primary"
                          disabled={!newListName?.trim()}
                          onClick={handleCreateNewList}
                        >
                          <i className="fa-solid fa-check" /> Create List
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
